import React from 'react';

import { DataExport } from 'upstream-shared/models';
import { DATA_EXPORTS_URL } from 'upstream-shared/urls';

export interface OwnProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  dataExport: DataExport;
  children?: React.ReactNode;
  afterDownload?: () => void;
}

// Experimented with window.open, but some browsers (Safari) block that because
// they're considered pop-ups.
const DataExportLink = (props: OwnProps) => {
  // const dispatch = useAppDispatch();
  const { dataExport, children, afterDownload, ...anchorProps } = props;
  const url = `/api${DATA_EXPORTS_URL}/${dataExport.id}/file`;
  const fileName = `${dataExport.data_type}_${dataExport.local_datetime}.zip`;
  let downloading = false;

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!downloading) {
      downloading = true;
      event.preventDefault();
      const anchor = event.currentTarget as HTMLAnchorElement;
      anchor.click();
      downloading = false;
      if (afterDownload) afterDownload();
    }
  };

  return (
    <a {...anchorProps} target="_blank" rel="noopener noreferrer" download={fileName} href={url} onClick={handleClick}>
      {children}
    </a>
  );
};

export default DataExportLink;
